<template>
  <div :class="$style['pt-qr-code-form']" v-loading="customerLoading">
      <pt-sub-title title="生成二维码信息"></pt-sub-title>
      <table :class="$style['qr-code-form-table']">
          <pt-form-list-item label="选择商品：" :required="true">
            <el-button plain type="primary" @click="selectGoods">点击选择商品</el-button>
            <div class="page-background" :class="$style['goods-selected-table-show']" v-if="goods_list">
            <table :class="$style['goods-table']">
                <tr>
                    <td>商品名称</td>
                    <td>价格（元）</td>
                    <td v-if="showStockQuantity">库存（件）</td>
                </tr>
                <tr>
                    <td>{{goods_list.goodsDTO&&goods_list.goodsDTO.goodsData&&goods_list.goodsDTO.goodsData.name}}</td>
                    <td>{{goods_list.final_price}}</td>
                    <td v-if="showStockQuantity">{{goods_list.goodsOtherInfoDTO&&goods_list.goodsOtherInfoDTO.stockQuantity}}</td>
                </tr>
            </table>
            </div>
        </pt-form-list-item>
         <pt-form-list-item label="选择用户：" :required="true">
         <select-user-fitter fromPage="promotion-form" :showBetchSelectUser="false" :selectUserList="selectUserList"
          @userSubmit="userSubmit" :disableSelect="disableSelect" @importLoading="importLoading">
         </select-user-fitter>
            <!-- <el-button plain type="primary"  @click="selectUser">点击选择用户</el-button>
             <div :class="$style['select-user-name']" v-if="selectUserList&&selectUserList.length">
                <span>已选择 {{firstUserName}} {{selectUserList.length > 1 ? ('等'  +selectUserList.length +'位用户...') : ''}}</span>
                <el-button type="text" @click="view_user">查看</el-button>
             </div> -->
        </pt-form-list-item>
      </table>
      <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog" :class="(is_select_user||is_view_user)?'user-dialog':(is_select_goods?'goods-dialog':'')">
          <select-for-goods @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" v-if="is_select_goods" :selected-goods="goods_list"
          :group-list="groupList" selectType="radio" :isRadioSelectButton="true"
        ></select-for-goods>
        <select-for-user :pageSize="5" v-if="is_select_user" @selectUsersSubmit="selectUsersSubmit" :selectedUser="selectUserList"  @close="closeDialog" ></select-for-user>
        <select-view-user v-if="is_view_user" :userIds="formValue.mallUserIds" @viewUserListDelete="viewUserListDelete" :pageEdit="true"  @close="closeDialog"></select-view-user>
      </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'

import selectForGoods from '../../select-for-goods'
import selectForUser from 'cps/customer-manage/select-for-user'
import selectViewUser from 'cps/customer-manage/select-view-user.vue'
import selectUserFitter from 'cps/base/select-user-fitter/index'
// 组件class前缀
const prefixCls = 'pt-qr-code-form'

export default {
  name: 'pt-qr-code-form',
  mixins: [formMixins],
  components: {
    selectForGoods,
    selectForUser,
    selectViewUser,
    selectUserFitter
  },
  props: {
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_select_goods || this.is_select_user || this.is_view_user
      },
      set: function (val) {
        this.is_select_goods = val
        this.is_select_user = val
        this.is_view_user = val
      }
    }
  },
  data () {
    return {
      formValue: {

      },
      firstUserName: '',
      selectUserList: [],
      goods_list: null,
      is_select_goods: false,
      is_select_user: false,
      is_view_user: false,
      dialog_title: '',
      showStockQuantity: false,
      disableSelect: false,
      customerLoading: false
    }
  },
  watch: {
    selectUserList: {
      handler: function (val) {
        if (val) {
          this.formValue.mallUserIds = []
          val.forEach(item => {
            this.formValue.mallUserIds.push(item.id)
          })
        }
      }
    },
    goods_list: {
      handler: function (val) {
        this.formValue.commodityId = val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.goodsId
        this.formValue.commodityName = val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.name
      }
    }
  },
  methods: {
    importLoading (val) {
      this.customerLoading = val
    },
    userSubmit (val) {
      if (val && val.userListId) {
        this.disableSelect = true
        let mallUserCriteria = {
          mallUserCriteria: {
            whiteList: [
              {
                userListId: val.userListId
              }
            ]

          }
        }
        this.formValue = { ...this.formValue, ...mallUserCriteria, ...val }
        this.$delete(this.formValue, 'userListId')
      } else {
        this.formValue = { ...this.formValue, ...val }
      }
      if (val && val.ids) {
        this.$set(this.formValue, 'mallUserIds', val.ids)
        this.$delete(this.formValue, 'ids')
      }
    },
    view_user () {
      this.dialog_title = '查看用户'
      this.is_view_user = true
    },
    closeDialog () {
      this.is_dialog = false
    },
    selectGoods () {
      this.is_select_goods = true
      this.dialog_title = '选择商品'
    },
    selectGoodsSubmit (val) {
      this.is_select_goods = false
      this.goods_list = val
    },
    selectUsersSubmit (val) {
      this.is_select_user = false
      let firstUserName = ''
      for (let i in val) {
        if (val[i].fullName) {
          firstUserName = val[i].fullName
          break
        }
      }
      this.selectUserList = val
      this.firstUserName = firstUserName
    },
    viewUserListDelete (val) {
      this.selectUserList = JSON.parse(JSON.stringify(val))
    },
    selectUser () {
      this.is_select_user = true
      this.dialog_title = '选择用户'
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-qr-code-form{
    :global
    .qr-code-form-table{
        padding: 10px 20px;
    }
}
.select-user-name{

}
.goods-table{
     display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.goods-selected-table-show{
    margin-top: 10px;
    max-width: 800px;
}
    :global
.user-dialog{
    .el-dialog{
        width: 70%;
        min-width: 1200PX;
        max-width:1500Px;
    }
    .el-dialog__body{
     padding: 0 20px 30px;
    }
}
</style>
